export default "__VITE_ASSET__ec75d9a3__"